import { render, staticRenderFns } from "./BeaconConfigModal.vue?vue&type=template&id=12a58c01&scoped=true"
import script from "./BeaconConfigModal.vue?vue&type=script&lang=js"
export * from "./BeaconConfigModal.vue?vue&type=script&lang=js"
import style0 from "./BeaconConfigModal.vue?vue&type=style&index=0&id=12a58c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a58c01",
  null
  
)

export default component.exports